export const GET_DISTRIBUTOR_LIST = 'get_distributor_list';
export const UPDATE_DISTRIBUTOR = 'update_distributor';
export const ADD_DISTRIBUTOR = 'add_distributor';
export const UPDATE_DISTRIBUTORS = 'update_distributors';
